module.exports = __webpack_public_path__ + "img/case_on.78253145.png";